import {jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import {Node} from '@tiptap/core'
import { NodeViewWrapper, ReactNodeViewRenderer} from '@tiptap/react'
import {lazy} from 'react'
import {appendColumn, appendRow, getColumns, getRows} from './data'

const DatabaseView = lazy(() => import(/* webpackChunkName: 'DatabaseView' */ './DatabaseView'))

export const DEFAULT_COLUMNS = [
  {name: 'Text column', type: 'text'},
  {name: 'Number column', type: 'number'},
  {name: 'Check column', type: 'check'}
] 

function Component(props) {
  const {editor, extension} = props

  return (
    _jsx(NodeViewWrapper, { className: "relative", children: 
      _jsx(DatabaseView, {
        provider: extension.options.provider,
        editor: editor,
        userId: extension.options.userId,}
      )
    })
  )
}






export const Database = Node.create({
  name: 'database',
  onCreate() {
    // Add some initial content to make the first use easier
    const {provider, userId} = this.options
    const document = _optionalChain([provider, 'optionalAccess', _ => _.document])
    if (!document) return
    if (getRows(document).length === 0) {
      if (getColumns(document).length === 0) {
        DEFAULT_COLUMNS.forEach((column) =>
          appendColumn(document, {name: column.name, type: column.type})
        )
      }
      appendRow(document, userId)
    }
  },
  renderHTML() {
    return ['div']
  },
  parseHTML() {
    return [{tag: 'database'}]
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component, {contentDOMElementTag: 'div'})
  }
})
